import { useEffect, useState } from 'react';

import WalletBalanceAndInput from './WalletBalanceWithdraw';
import WalletWithdrawalMethodsList from './WalletWithdrawalMethodsList';
import { useUser } from 'context/user';
import { useBridgeListExternalAccounts } from 'hooks/useBridgeSWR';
import WalletWithdrawalHistory from './WalletWithdrawlHistory';

const WalletWithdrawalMethodsAndBalance = () => {
  const { user } = useUser();
  const [selectedMethodId, setSelectedMethodId] = useState<string | null>();
  const {
    bridgeExternalAccounts,
    isPending: isBridgeExternalAccountsPending,
    mutateBridgeAccounts,
  } = useBridgeListExternalAccounts({
    bridgeCustomerID: user?.bridgeUserDetails?.customerId,
  });

  const handleSelectMethod = (methodId: string) => {
    setSelectedMethodId(methodId);
  };

  const selectedMethod = bridgeExternalAccounts?.find((account) => {
    // @ts-ignore
    return account.id === selectedMethodId;
  });

  // set selected method to the first external account if no method is selected
  useEffect(() => {
    if (!selectedMethodId && bridgeExternalAccounts?.length > 0) {
      // @ts-ignore
      setSelectedMethodId(bridgeExternalAccounts[0]?.id);
    }
  }, [bridgeExternalAccounts, selectedMethodId]);

  return (
    <>
      <div className="grid w-full grid-cols-1 gap-4 lg:grid-cols-5">
        <div className="col-span-1 lg:col-span-3">
          <WalletWithdrawalMethodsList
            handleSelectMethod={handleSelectMethod}
            selectedMethodId={selectedMethodId}
            bridgeExternalAccounts={bridgeExternalAccounts}
            isBridgeExternalAccountsPending={isBridgeExternalAccountsPending}
            mutateBridgeAccounts={mutateBridgeAccounts}
          />
        </div>
        <div className="col-span-1 space-y-4 lg:col-span-2">
          <WalletBalanceAndInput selectedMethod={selectedMethod} />
        </div>
      </div>
      <WalletWithdrawalHistory />
    </>
  );
};

export default WalletWithdrawalMethodsAndBalance;
